import React, { useReducer } from 'react';
import tareaContext from './tareaContext';
import tareaReducer from './tareaReducer';
import clienteAxios from '../../config/axios';
import Swal from 'sweetalert2';

import { 
    TAREAS_PROYECTO,
    AGREGAR_TAREA,
    VALIDACION_CAMPO,
    ELIMINAR_TAREA,
    TAREA_SELECCIONADA,
    ACTUALIZAR_TAREA,
    LIMPIAR_TAREA,
    VER_TAREA,
    TAREA_ACTUAL,
    OBTENER_DESCRIPCIONES,
    AGREGAR_DESCRIPCION,
    ELIMINAR_DESCRIPCION,
    DESCRIPCION_SELECCIONADA,
    LIMPIAR_DESCRIPCION,
    ACTUALIZAR_DESCRIPCION,
    CAMBIAR_FORMULARIO,
    REINICIAR_TAREA_STATE
} from '../../types';

const TareaState = props => {
    const initialState = {
        tareasproyecto: [],
        descripcionestarea: [],
        errorcampo: false,
        tareaseleccionada: null,
        descripcionseleccionada: null,
        vertarea: false,
        tareaactual: '',
        formulariodescripcion: false
    }

    // Crear dispatch y state
    const [state, dispatch] = useReducer(tareaReducer, initialState);

    // Funcion que obtiene la fecha actual
    const obtenerFechaActual = () => {
        var date = new Date();
        var hour = date.getHours();
        hour = (hour < 10 ? "0" : "") + hour;
        var min  = date.getMinutes();
        min = (min < 10 ? "0" : "") + min;
        var sec  = date.getSeconds();
        sec = (sec < 10 ? "0" : "") + sec;
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = (month < 10 ? "0" : "") + month;
        var day  = date.getDate();
        day = (day < 10 ? "0" : "") + day;
        return day + "/" + month + "/" + year + " - " + hour + ":" + min + ":" + sec;
    }

    // Funcion que esconde el formulario
    const esconderFormulario = (verdetalles) => {
        const formulario = document.querySelector('.formulario');
        const form = formulario.querySelector('form');
        const btn1 = document.querySelectorAll('.btns')[0];
        const btn2 = document.querySelectorAll('.btns')[1];
        const inputSubmit = document.querySelector('input[type="submit"]');

        if(verdetalles){
            formulario.classList.add('escondido-formulario');
            form.classList.add('escondido-form');
            btn1.classList.add('escondido-btns');
            btn2.classList.add('escondido-btns');
            inputSubmit.classList.add('escondido-input-submit');
        }else{
            formulario.classList.remove('escondido-formulario');
            form.classList.remove('escondido-form');
            btn1.classList.remove('escondido-btns');
            btn2.classList.remove('escondido-btns');
            inputSubmit.classList.remove('escondido-input-submit');
        }
    }

    // Función que modifica el estado de las tareas
    const cambiarEstado = tarea => {
        if(tarea.estado) {
            tarea.estado = false
        } else {
            tarea.estado = true;
        }
        actualizarTarea(tarea);
    }

    // Funcion que se ejecuta cuando el usuario presiona el btn de eliminar tarea
    const tareaEliminar = (id, proyectoId, vertarea) => {
        eliminarTarea(id, proyectoId);
        obtenerTareas(proyectoId);
        // Elimina tareaseleccionada del state
        limpiarTarea();
        if(vertarea){
            verTarea(false);
        }
    }

    // Agrega una tarea actual cuando el usuario desea editarla
    const seleccionarTarea = tarea => {
        guardarTareaSeleccionada(tarea);
    }
    
    // ********************
    // Crear las funciones
    // ********************

    // Obtener las tareas de un proyecto
    const obtenerTareas = async proyecto => {
        try {
            const resultado = await clienteAxios.get('/api/tareas', { params: { proyecto } });
            
            dispatch({
                type: TAREAS_PROYECTO,
                payload: resultado.data.tareas
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Agregar una tarea al proyecto seleccionado
    const agregarTarea = async tarea => {
        tarea.fechaCreacion = obtenerFechaActual();
        
        try {
            const resultado = await clienteAxios.post('/api/tareas', tarea);
            
            dispatch({
                type: AGREGAR_TAREA,
                payload: resultado.data.tarea
            });

            Swal.fire({
                title: '¡Agregada!',
                text: 'La tarea se agregó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error.response.data);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Valida y muestra un error en caso de que sea necesario
    const validarCampo = () => {
        dispatch({
            type: VALIDACION_CAMPO,
            payload: true
        });

        setTimeout(() => {
            dispatch({
                type: VALIDACION_CAMPO,
                payload: false
            });
        }, 5000);
    }

    // Eliminar tarea por id
    const eliminarTarea = async (id, proyecto) => {
        try {
            await clienteAxios.delete(`./api/tareas/${id}`, { params: { proyecto } });
            
            dispatch({
                type: ELIMINAR_TAREA,
                payload: id
            });

            Swal.fire({
                title: '¡Eliminada!',
                text: 'La tarea se eliminó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Editar una tarea
    const actualizarTarea = async tarea => {
        try {
            const resultado = await clienteAxios.put(`/api/tareas/${tarea._id}`, tarea);
            
            dispatch({
                type: ACTUALIZAR_TAREA,
                payload: resultado.data.tarea
            });
            
            Swal.fire({
                title: '¡Editada!',
                text: 'La tarea se editó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Extrae una tarea para edición
    const guardarTareaSeleccionada = tarea => {
        dispatch({
            type: TAREA_SELECCIONADA,
            payload: tarea
        })
    }
    
    // Elimina la tareaseleccionada
    const limpiarTarea = () => {
        dispatch({
            type: LIMPIAR_TAREA
        })
    }

    // Ver una tarea
    const verTarea = status => {
        dispatch({
            type: VER_TAREA,
            payload: status
        })
        limpiarTarea();
    }

    // Guardar tarea actual
    const tareaActual = tarea => {
        dispatch({
            type: TAREA_ACTUAL,
            payload: tarea
        })
    }

    // Obtener descripciones de una tarea
    const obtenerDescripciones = async tarea => {
        try {
            const resultado = await clienteAxios.get('/api/descripciones', { params: { tarea }});
            
            dispatch({
                type: OBTENER_DESCRIPCIONES,
                payload: resultado.data.descripciones
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Agregar una descripcion a la tarea actual
    const agregarDescripcion = async descripcion => {
        descripcion.fechaCreacion = obtenerFechaActual();

        try {
            const resultado = await clienteAxios.post('/api/descripciones', descripcion);
            
            dispatch({
                type: AGREGAR_DESCRIPCION,
                payload: resultado.data.descripcion
            });

            Swal.fire({
                title: '¡Agregada!',
                text: 'La descripción se agregó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Eliminar una descirpcion
    const eliminarDescripcion = async (id, tarea) => {
        try {
            await clienteAxios.delete(`/api/descripciones/${id}`, { params: { tarea }});
            
            dispatch({
                type: ELIMINAR_DESCRIPCION,
                payload: id
            });
            
            Swal.fire({
                title: '¡Eliminada!',
                text: 'La descripción se eliminó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
            
            obtenerDescripciones(tarea);
            limpiarDescripcion();
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Agrega una descripcion actual cuando el usuario desea editarla
    const seleccionarDescripcion = descripcion => {
        dispatch({
            type: DESCRIPCION_SELECCIONADA,
            payload: descripcion
        })
    }

    // Elimina la descripcionseleccionada
    const limpiarDescripcion = () => {
        dispatch({
            type: LIMPIAR_DESCRIPCION
        })
    }

    // Actualiza la lista de descripciones de una tarea al hacer un cambio
    const actualizarDescripcion = async descripcion => {
        try {
            const resultado = await clienteAxios.put(`/api/descripciones/${descripcion._id}`, descripcion);
            
            dispatch({
                type: ACTUALIZAR_DESCRIPCION,
                payload: resultado.data.descripcion
            });

            Swal.fire({
                title: '¡Editada!',
                text: 'La descripción se editó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error.response);
            Swal.fire(
                'Error',
                error.response.data.msg,
                'error'
            );
        }
    }

    // Cambia el state de cambiar formulario de descripcion a tarea
    const formularioDescripcion = status => {
        dispatch({
            type: CAMBIAR_FORMULARIO,
            payload: status
        })
    }

    const reiniciarTareaState = () => {
        dispatch({
            type: REINICIAR_TAREA_STATE
        })
    }

    return (
        <tareaContext.Provider
            value={{
                tareasproyecto: state.tareasproyecto,
                descripcionestarea: state.descripcionestarea,
                errorcampo: state.errorcampo,
                tareaseleccionada: state.tareaseleccionada,
                descripcionseleccionada: state.descripcionseleccionada,
                formulariodescripcion: state.formulariodescripcion,
                vertarea: state.vertarea,
                tareaactual: state.tareaactual,
                esconderFormulario,
                cambiarEstado,
                tareaEliminar,
                seleccionarTarea,
                obtenerTareas,
                agregarTarea,
                validarCampo,
                guardarTareaSeleccionada,
                actualizarTarea,
                limpiarTarea,
                verTarea,
                tareaActual,
                obtenerDescripciones,
                agregarDescripcion,
                eliminarDescripcion,
                seleccionarDescripcion,
                limpiarDescripcion,
                actualizarDescripcion,
                formularioDescripcion,
                reiniciarTareaState
            }}
        >
            {props.children}
        </tareaContext.Provider>
    )
}

export default TareaState;